// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__114d1","controls":"styles_controls__2dHxJ","charLimit":"styles_charLimit__3Fz1X","input":"styles_input__WwC9U","send":"styles_send__2iT7L"};